export default function AboutSection() {
  return (
    <section className="relative w-full py-24 md:py-32 lg:py-40 bg-background-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="mb-12">
          <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-400 font-medium">
            About
          </span>
        </div>
        <div className="space-y-8 md:space-y-10">
          <p className="text-lg md:text-xl lg:text-2xl text-foreground-800 leading-relaxed font-light">
            The team builds scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality. Every engineering decision is guided by a commitment to creating software that stands the test of time.
          </p>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
            Following modern software engineering practices, the team integrates clean architecture principles, rigorous performance optimization, and user-centered design into every phase of development. This ensures that each solution is not only technically robust but also intuitive and efficient for the people who rely on it.
          </p>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
            The approach is rooted in continuous improvement — refining development workflows, adopting up-to-date engineering standards, and exploring emerging technologies to stay at the forefront of the iOS ecosystem. The result is reliable, future-ready IT solutions that evolve alongside the platforms they are built for.
          </p>
        </div>
      </div>
    </section>
  );
}